import { FormControlLabel, Select, Switch } from "@mui/material";
import FormField from "components/FormField";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftMultiSelect";
import React, { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAgencyInfo } from "context/agency";
import useRequest from "hook/useRequest";
import { ReqMethods } from "enums";
import {
  useCreateSaasPlan,
  useCategoryPricing,
  useSaasStripeProducts,
  useCreateCategoryPricing,
} from "queries/saas";
import ReactSelect from "react-select";
import SoftTypography from "components/SoftTypography";
import ModelPromptslabels from "../../../UiPrompts/promptlabels/ModelPrompts/Create";
import { formatDate } from "@fullcalendar/core";
import Tooltip from "@mui/material/Tooltip";

const { POST } = ReqMethods;

const MultistepFormWizard = ({ onClose, handleRefresh }) => {
  const [step, setStep] = useState(1);
  const [loader, setLoader] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [agency] = useAgencyInfo();
  const request = useRequest();
  const queryClient = useQueryClient();
  const [aichanger, setaichanger] = useState(true);
  const [celenderchanger, setcelenderchanger] = useState(false);
  const [isFreeSaas, setIsFreeSaas] = useState(false);
  const [addTagModel, setAddTagModel] = useState(false);
  const [addCategoryModel, setAddCategoryModel] = useState(false);
  const [categoryFormData, setCategoryFormData] = useState([]);
  const [agents, setAgents] = useState([]);
  const [changedPlugins, setChangedPlugins] = useState([]);
  const [addToStripeProduct, setAddToStripeProduct] = useState(false);
  const [selectedStripeProducts, setSelectedStripeProducts] = useState([]);

  const [formData, setFormData] = useState({
    plan: { planName: "", description: "" },
    isFreeSaas: false,
    vat: null,
    category: { categorySelected: null, categoryOptions: null },
    pricing: { monthly_price: 0, yearly_price: 0, user_limit: 0, contact_limit: 0 },
    apps: { snapshotselected: ['AI Social App'] },
    trial_and_credit: { active_trile_period: false, add_credit: false, days: 0, credit_amount: 0 },
    rebilling: { ai_active: false, markupmargin: 1 },
    agency: { id: agency._id },
    celenderchanger: celenderchanger,
    additional_accounts: 0,
    additional_accounts_enabled: false,
    daily_token_usage: 0,
    selected_agents: [],
    promptlabel_ids: [],
    number_of_agents: "0",
    create_agents: false,
    add_plan_to_product: false,
    selected_plan_for_product: [],
  });

  const [errors, setErrors] = useState({});
  const validateStep1 = () => {
    const step1Errors = {};
    if (!formData.plan.planName.trim()) {
      step1Errors.planName = "Plan Name is required";
    }
    if (!formData.plan.description.trim()) {
      step1Errors.description = "Description is required";
    }
    setErrors(step1Errors);
    return Object.keys(step1Errors).length === 0;
  };
  const handleNext = () => {
    if (step === 1 && validateStep1()) {
      setStep(step + 1);
    } else if (step < 8) {
      setStep(step + 1);
    }
  };

  const handleCustomTab = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handlePrevious = () => {
    setStep(step - 1);
  };
  const { mutateAsync: createSaasPlan } = useCreateSaasPlan();

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    try {
      // Handle form submission logic here
      const payload = {
        ...formData,
        agenct_config: {
          plugins: changedPlugins,
          agent_limit: agentLimit,
          allow: toggleChecked,
        },
      };

      await createSaasPlan(payload, {
        onSuccess: ({ response }) => {
          if (response) {
            onClose();
            setLoader(false);
            queryClient.invalidateQueries({ queryKey: ["saas"] })
          }
          else {
            onClose()
            setLoader()
          }
        }
      });
    } catch {
      setLoader(false);
    }
  };
  const handleSelectChange_of_Category = (option) => {
    setFormData({
      ...formData,
      category: { ...formData.category, categoryOptions: option.value },
      category: { ...formData.category, categorySelected: option.value },
    });
  };

  const handleSelectChange_of_VAT = (option) => {
    setFormData({
      ...formData,
      vat: option.value,
    });
  };
  const handleSelectChange_of_promptlabels = (option) => {
    setFormData({
      ...formData,
      promptlabel_ids: option ? option.map((item) => item.value) : [],
    });
  };

  const handleSelectChange_of_agents = (option) => {
    setFormData({
      ...formData,
      selected_agents: option ? option.map((item) => item.value) : [],
    });
  };

  const handleSelectChange_of_stripe_products = (option) => {
    const selectedProducts = option ? option.map((item) => item.value) : [];
    setSelectedStripeProducts(option || []);
    setFormData({
      ...formData,
      selected_plan_for_product: selectedProducts,
    });
  };

  const handleToggleChange_toggle_phone_system_reselling = (event) => {
    setFormData({
      ...formData,
      rebilling: { ...formData.rebilling, ai_active: event.target.checked },
    });
  };
  const celenderappchanger = () => {
    setcelenderchanger(!celenderchanger);
    let updatedSnapshotSelected = [...formData.apps.snapshotselected];
    if (!celenderchanger) {
      // If celenderchanger is false, we are about to set it to true, so we push the value
      updatedSnapshotSelected.push("AI Celender App");
    } else {
      // If celenderchanger is true, we are about to set it to false, so we remove the value
      updatedSnapshotSelected = updatedSnapshotSelected.filter(
        (item) => item !== "AI Celender App"
      );
    }
    setFormData({
      ...formData,
      apps: { ...formData.apps, snapshotselected: updatedSnapshotSelected },
    });
  };
  const [activePlugins, setActivePlugins] = useState({});
  const [agentLimit, setAgentLimit] = useState(0);
  const [toggleChecked, setToggleChecked] = useState(true);
  const aiappchanger = () => {
    setaichanger(!aichanger);

    let updatedSnapshotSelected = [...formData.apps.snapshotselected];
    if (!aichanger) {
      // If aichanger is false, we are about to set it to true, so we push the value
      updatedSnapshotSelected.push("AI Social App");
    } else {
      // If aichanger is true, we are about to set it to false, so we remove the value
      updatedSnapshotSelected = updatedSnapshotSelected.filter(
        (item) => item !== "AI Celender App"
      );
    }
    setFormData({
      ...formData,
      apps: { ...formData.apps, snapshotselected: updatedSnapshotSelected },
    });
  };

  console.log(activePlugins, 'activePlugins')

  // Inlined rather than reused from queries/promptLabels.js's
  // useCreatePromptLabel - that hook doesn't pass toaster, and this call site
  // needs toaster:true preserved exactly as the old
  // AppService.promptslabel.create({ payload, toaster: true }) had it.
  const savedataPromptLabel = async (formData) => {
    const updatedFormData = {
      ...formData,
      agency_id: agency._id,
      type: "agency",
    };
    const payload = updatedFormData;
    //
    const { response } = await request(POST, "/promptslabel/create", { payload, toaster: true });
    if (response) {
      queryClient.invalidateQueries({ queryKey: ["prompt-labels"] });
      handleclose();
      setAddTagModel(false);
      onLoad();
    }
  };
  const handleclose = () => {
    setAddTagModel(false);
  };
  const handleAddTag = () => {
    setAddTagModel(true);
  };
  const handleAddCategory = () => {
    setAddCategoryModel(true);
  };

  const formatString = (str) =>
    str
      .replace(/_/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .trim();
  const { mutateAsync: createCategoryPricing } = useCreateCategoryPricing();
  const savecategory = async () => {
    categoryFormData.agency_id = agency._id;
    const payload = categoryFormData;
    const { response } = await createCategoryPricing(payload);
    if (response) {
      setAddCategoryModel(false);
      setCategoryFormData([]);
      onLoad();
    }
  };
  const handlePluginsChange = (agencyId, plugin) => {
    setActivePlugins((prev) => {
      const currentPlugins = prev[agencyId] || [];
      const pluginIndex = currentPlugins.findIndex((p) => p.id === plugin.id);

      let updatedPlugins;
      let newStatus;

      if (pluginIndex > -1) {
        newStatus = !currentPlugins[pluginIndex].is_active_for_plan;
        updatedPlugins = currentPlugins.map((p, idx) =>
          idx === pluginIndex
            ? { ...p, is_active_for_plan: newStatus }
            : p
        );
      } else {
        newStatus = true;
        updatedPlugins = [...currentPlugins, { id: plugin.id, is_active_for_plan: true }];
      }

      // Track changed plugins
      setChangedPlugins((prevChanged) => {
        // Remove if already present
        const filtered = prevChanged.filter((p) => p.id !== plugin.id);
        // Only add if status is different from original
        const originalStatus = agency?.default_plugins?.find((p) => p.id === plugin.id)?.is_active_for_plan;
        if (originalStatus !== newStatus) {
          return [...filtered, { id: plugin.id, is_active_for_plan: newStatus }];
        }
        return filtered;
      });

      return { ...prev, [agencyId]: updatedPlugins };
    });
  };
  const Change_of_currency = (option) => {
    setCategoryFormData({
      ...categoryFormData,
      currency: option.value,
    });
  };
  const availableCRNC = [
    { value: "usd", label: "$ USD" },
    { value: "eur", label: "€ Euro" },
    { value: "jpy", label: "¥ Japanese Yen" },
    { value: "gbp", label: "£ British Pound Sterling" },
    { value: "aud", label: "$ Australian Dollar" },
    { value: "cad", label: "$ Canadian Dollar" },
    { value: "chf", label: "Fr Swiss Franc" },
    { value: "cny", label: "¥ Chinese Yuan" },
    { value: "hkd", label: "HK$ Hong Kong Dollar" },
    { value: "nzd", label: "$ New Zealand Dollar" },
    { value: "sek", label: "kr Swedish Krona" },
    { value: "krw", label: "₩ South Korean Won" },
    { value: "sgd", label: "S$ Singapore Dollar" },
    { value: "nok", label: "kr Norwegian Krone" },
    { value: "mxn", label: "$ Mexican Peso" },
    { value: "inr", label: "₹ Indian Rupee" },
    { value: "rub", label: "₽ Russian Ruble" },
    { value: "zar", label: "R South African Rand" },
    { value: "brl", label: "R$ Brazilian Real" },
    { value: "try", label: "₺ Turkish Lira" },
    { value: "idr", label: "Rp Indonesian Rupiah" },
    { value: "thb", label: "฿ Thai Baht" },
    { value: "pln", label: "zł Polish Zloty" },
    { value: "php", label: "₱ Philippine Peso" },
    { value: "czk", label: "Kč Czech Koruna" },
    { value: "myr", label: "RM Malaysian Ringgit" },
    { value: "huf", label: "Ft Hungarian Forint" },
    { value: "isk", label: "kr Icelandic Króna" },
    { value: "hrk", label: "kn Croatian Kuna" },
    { value: "dkk", label: "kr Danish Krone" },
    { value: "ils", label: "₪ Israeli Shekel" },
    { value: "ars", label: "$ Argentine Peso" },
    { value: "clp", label: "$ Chilean Peso" },
    { value: "cop", label: "$ Colombian Peso" },
    { value: "pen", label: "S/. Peruvian Sol" },
    { value: "uah", label: "₴ Ukrainian Hryvnia" },
    { value: "egp", label: "£ Egyptian Pound" },
    { value: "sar", label: "ر.س Saudi Riyal" },
    { value: "aed", label: "د.إ UAE Dirham" },
    { value: "vnd", label: "₫ Vietnamese Dong" },
    { value: "kes", label: "KSh Kenyan Shilling" },
    { value: "ngn", label: "₦ Nigerian Naira" },
    { value: "pkr", label: "₨ Pakistani Rupee" },
    { value: "ghs", label: "₵ Ghanaian Cedi" },
    { value: "ugx", label: "USh Ugandan Shilling" },
    { value: "bdt", label: "৳ Bangladeshi Taka" },
    { value: "qar", label: "ر.ق Qatari Riyal" },
    { value: "lbp", label: "ل.ل Lebanese Pound" },
    { value: "mad", label: "د.م. Moroccan Dirham" },
    { value: "cup", label: "$ Cuban Peso" },
    { value: "crc", label: "₡ Costa Rican Colón" },
    { value: "npr", label: "₨ Nepalese Rupee" },
    { value: "hnl", label: "L Honduran Lempira" },
    { value: "gtq", label: "Q Guatemalan Quetzal" },
    { value: "pab", label: "B/. Panamanian Balboa" },
    { value: "uyu", label: "$U Uruguayan Peso" },
    { value: "bob", label: "Bs. Bolivian Boliviano" },
    { value: "pyg", label: "₲ Paraguayan Guarani" },
    { value: "etb", label: "ብር Ethiopian Birr" },
    { value: "awg", label: "ƒ Aruban Florin" },
    { value: "bsd", label: "$ Bahamian Dollar" },
    { value: "bbd", label: "$ Barbadian Dollar" },
    { value: "bzd", label: "BZ$ Belize Dollar" },
    { value: "bmd", label: "$ Bermudian Dollar" },
    { value: "kyd", label: "$ Cayman Islands Dollar" },
    { value: "fjd", label: "$ Fijian Dollar" },
    { value: "gyd", label: "$ Guyanese Dollar" },
    { value: "jmd", label: "J$ Jamaican Dollar" },
    { value: "lrd", label: "$ Liberian Dollar" },
    { value: "nad", label: "$ Namibian Dollar" },
    { value: "srd", label: "$ Surinamese Dollar" },
    { value: "ttd", label: "TT$ Trinidad and Tobago Dollar" },
    { value: "xcd", label: "$ East Caribbean Dollar" },
    { value: "sbd", label: "$ Solomon Islands Dollar" },
  ];

  const vatOptions = [
    { value: "no_vat", label: "No VAT" },
    { value: "vat_included", label: "VAT is included in the plan price" },
    { value: "vat_excluded", label: "VAT is excluded in the plan price" },
  ];
  const handleToggleChange = async () => {
    setToggleChecked((prev) => !prev);
  };
  const { data: stripeProductsResponse } = useSaasStripeProducts(agency._id);
  const getStripeProducts = (stripeProductsResponse?.data || []).map((item) => ({
    label: item.name,
    value: item.id,
  }));

  // ponytail: fetchAgents (AppService.assistant.Getassistant) was dead code -
  // defined but never called anywhere in this file - dropped rather than
  // migrated, same as configration/index.js's identical dead fetchAgents.

  const { data: categoryPricingResponse } = useCategoryPricing(agency._id);
  const currencies = (categoryPricingResponse?.data || []).map((item) => ({ label: item.name, value: item._id }));
  const promplabels = categoryPricingResponse?.promptslabel || [];
  // Replaces the old "refetch category pricing" local loader - kept the same
  // name since savedataPromptLabel/savecategory above still call onLoad().
  const onLoad = () => queryClient.invalidateQueries({ queryKey: ["saas-category-pricing"] });

  useEffect(() => {
    if (agency?.default_plugins) {
      const defaultActive = agency.default_plugins
        .filter((plugin) => plugin.is_active_for_plan)
        .map((plugin) => ({
          id: plugin.id,
          is_active_for_plan: true,
        }));
      setActivePlugins({
        [agency.location_id]: defaultActive,
      });
    }
  }, [agency]);

  const handleInputChange = (event) => {
    const tempSliderValue = event.target.value;
    if (tempSliderValue < 1) {
      return true;
    }
    setFormData({
      ...formData,
      rebilling: { ...formData.rebilling, markupmargin: tempSliderValue },
    });

    const progress = (tempSliderValue / event.target.max) * 100;

    event.target.style.background = `linear-gradient(to right, gray ${progress}%, #ccc ${progress}%)`;
  };

  const handleIsFreeSaas = () => {
    setIsFreeSaas((prevState) => {
      const newValue = !prevState;
      setFormData({
        ...formData,
        isFreeSaas: newValue, // Use the updated value here
      });
      return newValue;
    });
  };

  console.log(formatDate?.number_of_agents, "formatDate.number_of_agents");
  console.log(agency, 'agency')

  return (
    <div className="container mt-4">
      <div className="flex justify-center">
        <div className="w-full lg:w-3/4">
          <div className=" bg-white shadow-lg rounded-lg p-6">
            <div>
              <form>
                {step === 1 && (
                  <>
                    <div className="text-left mb-4">
                      <label htmlFor="planName" className="block mb-1 text-black">
                        Plan Name
                      </label>
                      <input
                        type="text"
                        id="planName"
                        className="form-control-agust w-full"
                        value={formData.plan.planName}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            plan: { ...formData.plan, planName: e.target.value },
                          })
                        }
                      />
                      {errors.planName && (
                        <small className="text-red-500" style={{ fontSize: "14px" }}>
                          {errors.planName}
                        </small>
                      )}
                    </div>
                    <div className="text-left mb-4">
                      <label htmlFor="description" className="block mb-1 text-black">
                        Description
                      </label>
                      <input
                        style={{ width: "100%", border: "1px solid #d8cbcb" }}
                        type="text"
                        id="description"
                        className="form-control-agust   w-full"
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            plan: { ...formData.plan, description: e.target.value },
                          })
                        }
                        value={formData.plan.description}
                      />
                      {errors.description && (
                        <small className="text-red-500" style={{ fontSize: "14px" }}>
                          {errors.description}
                        </small>
                      )}
                    </div>

                    <div className="text-left mb-4">
                      <SoftTypography
                        className="text-black w-100 d-flex justify-content-between"
                        variant="button"
                        sx={{ fontSize: "14px", fontWeight: "500" }}
                        mt={1}
                      >
                        <label className="w-50 new_dezin_label text-black ">VAT</label>
                      </SoftTypography>

                      <ReactSelect
                        name="vat"
                        className="form-input w-full"
                        options={vatOptions}
                        isMultiple={false}
                        onChange={handleSelectChange_of_VAT}
                      />
                    </div>

                    <div className="text-left mb-4">
                      <SoftTypography
                        className="text-black w-100 d-flex justify-content-between"
                        variant="button"
                        sx={{ fontSize: "14px", fontWeight: "500" }}
                        mt={1}
                      >
                        <label className="w-50 new_dezin_label text-black ">CURRENCY</label>
                        <p
                          className="w-50 text-right new_dezin_label text-black cursor-pointer"
                          onClick={handleAddCategory}
                        >
                          + CURRENCY
                        </p>
                      </SoftTypography>

                      <ReactSelect
                        name="category"
                        className="form-input w-full"
                        // defaultValue={{ value: "clothing", label: "Clothing" }}
                        options={currencies}
                        isMultiple={false}
                        onChange={handleSelectChange_of_Category}
                      />
                    </div>

                    <div
                      className="text-left mb-4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <input
                        type="checkbox"
                        name="isFreeSaas"
                        onChange={handleIsFreeSaas}
                        value={isFreeSaas}
                      />
                      <label
                        htmlFor="email"
                        className="block mb-1 text-black"
                        style={{ marginLeft: "14px" }}
                      >
                        Is it a Free SaaS plan?
                      </label>
                    </div>
                    {!isFreeSaas && (
                      <div className="d-flex justify-content-between">
                        <div className="text-left mb-4">
                          <label htmlFor="planName" className="block text-black">
                            Monthly Price
                          </label>
                          <input
                            type="number"
                            id="monthly_price"
                            name="monthly_price"
                            className="form-control-agust  w-full"
                            value={formData.pricing.monthly_price}
                            defaultValue={0}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                pricing: { ...formData.pricing, monthly_price: e.target.value },
                              })
                            }
                          />
                        </div>
                        <div className="mb-4 text-left" style={{ margin: "0px 0px 0px 5px" }}>
                          <label htmlFor="planName" className="text-black">
                            Annual Price
                          </label>
                          <input
                            type="number"
                            id="yearly_price"
                            className="form-control-agust  w-full"
                            name="yearly_price"
                            value={formData.pricing.yearly_price}
                            defaultValue={0}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                pricing: { ...formData.pricing, yearly_price: e.target.value },
                              })
                            }
                          />
                        </div>
                      </div>
                    )}
                    <div style={{ gap: "5px" }} className="d-flex justify-content-between">
                      <div className="text-left mb-4" style={{ width: "50%" }}>
                        <label htmlFor="planName" className="block text-black">
                          User Limit
                        </label>
                        <input
                          type="number"
                          id="user_limit"
                          className="form-control-agust  w-full"
                          name="user_limit"
                          value={formData.pricing.user_limit}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              pricing: { ...formData.pricing, user_limit: e.target.value },
                            })
                          }
                        />
                      </div>
                    </div>
                  </>
                )}
                {step === 2 && (
                  <>
                    <div className="text-left mb-4">
                      <p className=" text-black font-15">
                        {" "}
                        Select the features you’d like to enable for this plan:
                      </p>
                      <div className="d-flex justify-between"></div>
                      <div style={{ marginTop: "14px" }}>
                        <div className="d-flex justify-between">
                          <div className="">
                            <p className="font-16 text-black">Your AI</p>
                          </div>
                          <div className=" ">
                            <Switch
                              className={aichanger ? "switch-active" : "switch-inactive"}
                              checked={aichanger}
                              onChange={aiappchanger}
                            />
                          </div>
                        </div>
                        {/* <div
                          className="d-flex justify-between card_agust_row"
                          style={{ marginBottom: "14px" }}
                        >
                          <div className="">
                            <p className="font-16 text-black">Content Creation Calendar</p>
                          </div>
                          <div className=" ">
                            <Switch checked={celenderchanger} onChange={celenderappchanger} />
                          </div>
                        </div> */}

                        <hr style={{ width: "100%", marginTop: "14px", marginBottom: "14px" }} />


                        <div style={{ marginTop: "14px" }}>
                          <SoftTypography
                            className="text-black w-100 d-flex justify-content-between"
                            variant="button"
                            sx={{ fontSize: "14px", fontWeight: "500" }}
                            mb={1}
                          >
                            <label className="w-50 new_dezin_label text-black ">
                              Available AI Agent Templates
                            </label>
                            {/* <p className='w-50 text-right new_dezin_label text-black cursor-pointer' onClick={handleAddTag}>
                              + Add Tag
                            </p> */}
                          </SoftTypography>
                          <ReactSelect
                            isMulti
                            name="promptlabel_ids"
                            className="form-input w-full"
                            options={
                              Array.isArray(promplabels)
                                ? promplabels
                                  .filter(
                                    (item) => item.api_type === "user" || item.api_type === "team"
                                  )
                                  .map((item) => ({
                                    label: item?.template?.templatename
                                      ? item?.template?.templatename
                                      : item?.name,
                                    value: item._id,
                                  }))
                                : []
                            }
                            value={
                              Array.isArray(promplabels)
                                ? promplabels
                                  .filter((item) => formData?.promptlabel_ids?.includes(item._id))
                                  .map((item) => ({
                                    label: item?.template?.templatename
                                      ? item?.template?.templatename
                                      : item?.name,
                                    value: item._id,
                                  }))
                                : []
                            }
                            onChange={handleSelectChange_of_promptlabels}
                          />
                        </div>
                        {/* <div style={{ marginTop: "14px" }}>
                          <SoftTypography
                            className="text-black w-100 d-flex justify-content-between"
                            variant="button"
                            sx={{ fontSize: "14px", fontWeight: "500" }}
                            mb={1}
                          >
                            <label className="w-50 new_dezin_label text-black ">
                              Select Agents
                            </label>
                          </SoftTypography>
                          <ReactSelect
                            isMulti
                            name="selected_agents"
                            className="form-input w-full"
                            options={agents}
                            value={agents.filter((agent) =>
                              formData?.selected_agents?.includes(agent.value)
                            )}
                            onChange={handleSelectChange_of_agents}
                            placeholder="Select agents..."
                          />
                        </div> */}
                      </div>
                    </div>
                  </>
                )}

                {step === 3 && (
                  <>
                    <div className="text-left mb-4">
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' }}>
                        <p className="text-black font-15" style={{ margin: 0 }}>
                          Enable the plugins and set the agent limit for this plan:
                        </p>
                        <Tooltip title="Please give your agents access to integration to work better and perform specific tasks more effectively. " arrow>
                          <div style={{
                            width: '20px',
                            height: '20px',
                            borderRadius: '50%',
                            borderColor: '#fff',
                            background: '#000',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            cursor: 'pointer'
                          }}>
                            i
                          </div>
                        </Tooltip>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: '16px 0',
                          borderBottom: '1px solid #E0E0E0'
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span style={{ fontSize: "16px", fontWeight: '500', color: '#000' }}>
                            Enable plugin configurations
                          </span>
                          <Tooltip title="Master toggle for all plugin configurations" arrow>
                            <div style={{
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              background: '#000',
                              color: '#fff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '12px',
                              fontWeight: 'bold',
                              cursor: 'pointer'
                            }}>
                              i
                            </div>
                          </Tooltip>
                        </div>
                        <Switch checked={toggleChecked} onChange={handleToggleChange} />
                      </div>

                      {toggleChecked && (
                        <div style={{ marginTop: '16px' }}>
                          {agency?.default_plugins?.filter((plugin) => plugin.is_active_for_agency).map((plugin) => (
                            <div
                              key={plugin?.id}
                              style={{
                                padding: '16px 0',
                                borderBottom: '1px solid #F5F5F5'
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <label style={{ fontSize: "16px", fontWeight: '500', color: '#000', margin: 0 }}>
                                    {formatString(plugin.name).toUpperCase()}
                                  </label>
                                  {/* <Tooltip title={plugin?.metadata?.description || ` ${formatString(plugin.name)} plugin`} arrow>
                                    <div style={{
                                      width: '20px',
                                      height: '20px',
                                      borderRadius: '50%',
                                      background: '#000',
                                      color: '#fff',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontSize: '12px',
                                      fontWeight: 'bold',
                                      cursor: 'pointer'
                                    }}>
                                      i
                                    </div>
                                  </Tooltip> */}
                                </div>
                                <Switch
                                  checked={
                                    (activePlugins[agency?.location_id] || []).some(
                                      (p) => p.id === plugin?.id && p.is_active_for_plan
                                    )
                                  }
                                  onChange={() => handlePluginsChange(agency?.location_id, plugin)}
                                  name={plugin?.name}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </>
                )}
                {step === 4 && (
                  <>
                    <div className="text-left mb-4">
                      <div className="margin-top-10px">
                        <h2 className="text-black font-16">Trial period</h2>
                        <p className="font-15">
                          Enter the number of days for which a trial can be used.{" "}
                        </p>
                        <input
                          type="number"
                          className="margin-top-10px form-control-agust"
                          min="1"
                          max="100"
                          value={formData.trial_and_credit.days}
                          onChange={(e) => {
                            const newDaysValue = e.target.value;
                            setFormData({
                              ...formData,
                              trial_and_credit: {
                                ...formData.trial_and_credit,
                                days: newDaysValue,
                                active_trile_period: newDaysValue !== "0",
                              },
                            });
                          }}
                          style={{ width: "50%" }}
                        />
                      </div>
                    </div>
                    <div className="text-left mb-4 ">
                      <div className=" margin-top-10px">
                        <h2 className="text-black font-16">Add Credit</h2>
                        <p className="font-15">
                          When users sign up, offer them a complimentary credit for their AI usage.
                        </p>

                        <input
                          type="number"
                          className="margin-top-10px form-control-agust"
                          min="1"
                          max="100"
                          value={formData.trial_and_credit.credit_amount}
                          onChange={(e) => {
                            const newCreditValue = e.target.value;
                            setFormData({
                              ...formData,
                              trial_and_credit: {
                                ...formData.trial_and_credit,
                                credit_amount: newCreditValue,
                                add_credit: newCreditValue !== "0",
                              },
                            });
                          }}
                          style={{ width: "50%" }}
                        />
                      </div>
                    </div>

                    <div className="mb-4" style={{ marginTop: "10px", textAlign: "left" }}>
                      <h2 className="text-black font-16">Your AI tokens</h2>
                      <p className="font-15 ">
                        Enter the number of your AI monthly token for this plan a token is calculate
                        every time client enter button occurs which enables you to invoke a fair
                        usage policy.
                      </p>

                      <input
                        type="number"
                        id="daily_token_usage"
                        className="form-control-agust"
                        name="daily_token_usage"
                        style={{ marginTop: "10px", textAlign: "left", width: "50%" }}
                        value={formData.daily_token_usage}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            daily_token_usage: e.target.value,
                          })
                        }
                      />
                    </div>
                  </>
                )}
                {step === 5 && (
                  <>
                    <div className="text-left mb-4 margin-top-10px">
                      <div className="d-flex justify-between card_agust_row">
                        <div className="">
                          <p className="font-16 text-black">AI Charges</p>
                        </div>
                        <div className=" ">
                          <Switch
                            checked={formData.rebilling.ai_active}
                            onChange={handleToggleChange_toggle_phone_system_reselling}
                          />
                        </div>
                      </div>

                      <div
                        className={`margin-top-10px ${formData.rebilling.ai_active ? "" : "diabled-div"
                          }`}
                      >
                        <h5 className="font-15 text-black">Markup Margin</h5>
                        <p className="font-15">
                          These margins are billed to your clients for their AI usage
                          <br></br>
                          <input
                            type="range"
                            min="0"
                            max="100"
                            onChange={handleInputChange}
                            id="range2"
                            className="range-input"
                            value={formData.rebilling.markupmargin}
                          />
                          {formData.rebilling.markupmargin} Times
                        </p>
                        <div className="heightmanagmable">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <div style={{ width: "32%" }}>
                              <label className="text-black">API Cost Price</label>
                              <div className="form-control-agust-gray font-16">
                                {agency?.charge_per_api || 0.01}/API
                              </div>
                            </div>
                            <div style={{ width: "32%" }}>
                              <label>API Selling Price</label>
                              <div className="form-control-agust-gray font-16">
                                {`${agency?.charge_per_api || 0.01} x ${formData.rebilling.markupmargin
                                  } = ${(
                                    (agency?.charge_per_api || 0.01) * formData.rebilling.markupmargin
                                  ).toFixed(3)}`}
                              </div>
                            </div>
                            <div style={{ width: "32%" }}>
                              <label>Profit</label>
                              <div className="form-control-agust-success font-16">
                                {`${parseFloat(
                                  (
                                    (agency?.charge_per_api || 0.01) * formData.rebilling.markupmargin -
                                    (agency?.charge_per_api || 0.01)
                                  ).toFixed(3)
                                )}`}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {step === 6 && (
                  <>
                    <div className="text-left mb-4 margin-top-10px">
                      <div className="d-flex justify-between " style={{ alignItems: "center" }}>
                        <div className="">
                          <p
                            className="font-16 text-black font-bold"
                            style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
                          >
                            <svg
                              width="29"
                              height="29"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="black"
                            >
                              {/* Top circle with 1 */}
                              <circle
                                cx="70"
                                cy="70"
                                r="30"
                                stroke="black"
                                strokeWidth="10"
                                fill="none"
                              />
                              <rect
                                x="65"
                                y="55"
                                width="10"
                                height="30"
                                rx="5"
                                ry="5"
                                fill="black"
                              />

                              {/* Bottom rotated semi-circle with slash */}
                              <path
                                d="M130 100 a30 30 0 1 1 -21 8"
                                stroke="black"
                                strokeWidth="10"
                                fill="none"
                              />
                              <rect
                                x="115"
                                y="105"
                                width="10"
                                height="30"
                                rx="5"
                                ry="5"
                                fill="black"
                                transform="rotate(45 120 120)"
                              />
                            </svg>
                            <span>Create AI Agents</span>
                          </p>
                          <span style={{ color: "#757575", fontSize: "14px", marginLeft: "8px" }}>
                            Can this plan create AI Agent
                          </span>
                        </div>
                        <div className=" ">
                          <Switch
                            checked={formData.create_agents}
                            onChange={(e) =>
                              setFormData({ ...formData, create_agents: e.target.checked })
                            }
                          />
                        </div>
                      </div>

                      {formData?.create_agents && (
                        <div
                          className="d-flex justify-between margin-top-10px"
                          style={{ alignItems: "center" }}
                        >
                          <div className="">
                            <p
                              className="font-16 text-black font-bold"
                              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
                            >
                              <span>Unlimited</span>
                            </p>
                            <span style={{ color: "#757575", fontSize: "14px", marginLeft: "8px" }}>
                              This plan can create unlimited AI Agents
                            </span>
                          </div>
                          <div className=" ">
                            <Switch
                              checked={formData.number_of_agents === "infinite"}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  number_of_agents: e.target.checked ? "infinite" : "0",
                                })
                              }
                            />
                          </div>
                        </div>
                      )}

                      {formData?.number_of_agents === "0" && (
                        <div className={`margin-top-10px`}>
                          <p
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              marginLeft: "8px",
                              marginTop: "14px",
                            }}
                          >
                            Number of AI Agents
                          </p>
                          <p style={{ color: "#757575", fontSize: "14px", marginLeft: "8px" }}>
                            How many AI Agent can this plan create?
                          </p>
                          <input
                            style={{
                              marginLeft: "8px",
                              marginBlock: "14px",
                              width: "95%",
                              borderRadius: "4px",
                              padding: "10px",
                              fontSize: "14px",
                            }}
                            type="number"
                            value={parseInt(formData.number_of_agents)}
                            onChange={(e) =>
                              setFormData({ ...formData, number_of_agents: e.target.value })
                            }
                            min={0}
                          />
                        </div>
                      )}
                    </div>
                  </>
                )}

                {step === 7 && (
                  <>
                    <div className="text-left mb-4">
                      <div className="d-flex justify-between card_agust_row">
                        <div className="">
                          <p className="font-16 text-black">Create additional accounts</p>
                          <p className="font-15">Can this plan create additional accounts?</p>
                        </div>
                        <div className=" ">
                          <Switch
                            checked={formData.additional_accounts_enabled || false}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                additional_accounts_enabled: e.target.checked,
                              })
                            }
                          />
                        </div>
                      </div>

                      {formData.additional_accounts_enabled && (
                        <div className="text-left mb-4 mt-4">
                          <label htmlFor="additional_accounts" className="block text-black mb-2">
                            Number of additional accounts
                          </label>
                          <p className="font-15 mb-2">
                            How many additional accounts can this plan create
                          </p>
                          <input
                            type="number"
                            id="additional_accounts"
                            className="form-control-agust w-full"
                            name="additional_accounts"
                            value={formData.additional_accounts}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                additional_accounts: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}
                    </div>
                  </>
                )}

                {step === 8 && (
                  <>
                    <div className="text-left mb-4">
                      <h2 className="text-black font-18 mb-3">Add Plan to existing Stripe product</h2>
                      <div className="d-flex justify-between card_agust_row" style={{ alignItems: "center" }}>
                        <div className="">
                          <p className="font-16 text-black">Add this plan to an existing Stripe product</p>
                        </div>
                        <div className=" ">
                          <Switch
                            checked={addToStripeProduct}
                            onChange={(e) => {
                              setAddToStripeProduct(e.target.checked);
                              setFormData({
                                ...formData,
                                add_plan_to_product: e.target.checked,
                              });
                            }}
                          />
                        </div>
                      </div>

                      {addToStripeProduct && (
                        <div className="text-left mb-4 mt-4">
                          <label htmlFor="select_product" className="block text-black mb-2">
                            Select products
                          </label>
                          <ReactSelect
                            isMulti
                            name="stripe_product"
                            className="form-input w-full"
                            options={getStripeProducts}
                            value={selectedStripeProducts}
                            onChange={handleSelectChange_of_stripe_products}
                            placeholder="Select Stripe products"
                          />
                        </div>
                      )}
                    </div>
                  </>
                )}

                <div className="d-flex mt-6" style={{ justifyContent: "center", alignItems: "center", marginTop: "20px" }}>
                  <button
                    className="savebtn-setting "
                    style={{ marginTop: "10px", width: "30%", color: "#000", backgroundColor: "#fff" }}
                    type="button"
                    onClick={() => handleCustomTab()}
                  >
                    Back
                  </button>

                  <div
                    className="d-flex  center"
                    style={{ width: "100%", justifyContent: "center", gap: "8px" }}
                  >
                    <span className={step === 1 ? "color-active-new" : "color-inactive-new"}></span>
                    <span className={step === 2 ? "color-active-new" : "color-inactive-new"}></span>
                    <span className={step === 3 ? "color-active-new" : "color-inactive-new"}></span>
                    <span className={step === 4 ? "color-active-new" : "color-inactive-new"}></span>
                    <span className={step === 5 ? "color-active-new" : "color-inactive-new"}></span>
                    <span className={step === 6 ? "color-active-new" : "color-inactive-new"}></span>
                    <span className={step === 7 ? "color-active-new" : "color-inactive-new"}></span>
                    <span className={step === 8 ? "color-active-new" : "color-inactive-new"}></span>
                  </div>

                  {step < 8 && (
                    <button
                      className="savebtn-setting"
                      style={{ marginTop: "10px", width: "30%" }}
                      type="button"
                      onClick={handleNext}
                    >
                      Next
                    </button>
                  )}
                  {step === 8 && (
                    <button
                      className="savebtn-setting "
                      style={{ marginTop: "10px", width: "40%" }}
                      onClick={handleFormSubmit}
                      disabled={loader}
                    >
                      {loader ? "Waiting..." : "Submit"}
                    </button>
                  )}
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>

      {addCategoryModel && (
        <div className="modal-zz-confirm text-left">
          <div
            className="scrollable-modal-content bg-white rounded"
            style={{ position: "relative" }}
          >
            <h2 className="text-black text-left font-14" style={{ marginBottom: "10px" }}>
              Add New Currency
            </h2>
            <span className="crossison" onClick={() => setAddCategoryModel(false)}>
              X
            </span>
            <input
              type="text"
              id="category"
              className="form-control-agust w-full"
              name="category"
              placeholder={"Enter Currency Name "}
              value={categoryFormData.category}
              onChange={(e) =>
                setCategoryFormData({
                  ...categoryFormData,
                  name: e.target.value,
                })
              }
            />
            <div style={{ margin: "10px 0px" }}>
              <ReactSelect
                className="form-input w-full"
                options={availableCRNC}
                isMulti={false}
                onChange={Change_of_currency}
                menuPortalTarget={document.body} // Render dropdown outside the modal
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Set z-index for visibility
                }}
              />
            </div>
            <div className="w-100 margin-top-20px">
              <button type="submit" className="btn-newdezine" onClick={savecategory}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {addTagModel && (
        <ModelPromptslabels
          data={null}
          modelfunctionality={savedataPromptLabel}
          openModel={addTagModel}
          onclosemodel={handleclose}
        />
      )}
    </div>
  );
};

export default MultistepFormWizard;
